import React, { useCallback, useMemo, useReducer } from 'react';

import vacanciesConstants    from './vacancies.constants';
import VacanciesContext      from './vacancies.context';
import vacanciesReducer      from './vacancies.reducer';
import vacanciesInitialState from './vacancies.state';

import useRequest from '../../common/services/request';

function VacanciesProvider({
  children,
  value,
}) {

  const [state, dispatch] = useReducer(vacanciesReducer, {
    ...vacanciesInitialState,
    contactButtonName: value.contactButtonName || vacanciesInitialState.contactButtonName,
    headImage:         value.headImage || vacanciesInitialState.headImage,
    vacanciesIsLoaded: value.items && value.items.length > 0,
    isIndexed:         value.isIndexed || vacanciesInitialState.isIndexed,
    items:             value.items || vacanciesInitialState.items,
    inCatalogLabel:    value.inCatalogLabel || vacanciesInitialState.inCatalogLabel,
    inCatalogLink:     value.inCatalogLink || vacanciesInitialState.inCatalogLink,
    label:             value.label || vacanciesInitialState.label,
    meta:              {
      title: value.metaTitle || vacanciesInitialState.meta.title,
      meta:  {
        keywords:    value.metaKeywords || vacanciesInitialState.meta.meta.keywords,
        description: value.metaDescription || vacanciesInitialState.meta.meta.description,
        canonical:   value.metaCanonical || vacanciesInitialState.meta.meta.canonical,
      },
    },
    template:          value.template || vacanciesInitialState.template,
  });

  const request = useRequest();

  const getVacanciesList = useCallback(() => {
    dispatch({ type: vacanciesConstants.GET_VACANCIES_REQUEST });

    return request.get('/api/vacancies')
      .then((response) => dispatch({ type: vacanciesConstants.GET_VACANCIES_SUCCESS, ...response }))
      .catch((error) => dispatch({ type: vacanciesConstants.GET_VACANCIES_FAILURE, ...error }));

  }, [dispatch]);

  const context = useMemo(() => ({
    ...state,
    getVacanciesList,
  }), [getVacanciesList, state]);

  return (
    <VacanciesContext.Provider value={context}>
      {children}
    </VacanciesContext.Provider>
  );
}

export default VacanciesProvider;